import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

import styles from './ContemporaryLandingStyleRowItem.scss';
import { trackEvent } from 'dibs-tracking';

const trackClick = item => {
    trackEvent({
        action: 'featured collection',
        category: 'contemporary landing page interaction',
        label: `collection clicked|${item.title}`,
    });
};

export const ContemporaryLandingStyleRowItem = ({ item, rowIndex }) => {
    if (!item) {
        return null;
    }

    const wrapperClasses = classnames('colXs12 colLg4', styles.rowItem, {
        [styles.firstRow]: rowIndex === 0,
    });

    return (
        <a className={wrapperClasses} href={item.url} onClick={() => trackClick(item)}>
            <div className="rowFlex">
                <div className="colXs6 colLg12">
                    <div className={styles.imageWrapper}>
                        {item.imagePath ? (
                            <img className={styles.image} src={item.imagePath} alt={item.title} />
                        ) : (
                            <div className={styles.imagePlaceholder} />
                        )}
                    </div>
                </div>
                <div className="colXs6 colLg12">
                    <h2 className={styles.title}>{item.title}</h2>
                    {item.cta && <p className={styles.cta}>{item.cta}</p>}
                    {item.description && <p className={styles.text}>{item.description}</p>}
                </div>
            </div>
        </a>
    );
};

ContemporaryLandingStyleRowItem.propTypes = {
    item: PropTypes.object,
    rowIndex: PropTypes.number.isRequired,
};
